/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig,
    FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsAuth
 * Публичные данные по аутентификации
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsAuth = FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig;

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAuth {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAuth {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig);
    }

    return {};
}

